import { useState, useCallback } from 'react'

const useContainerWidth = () => {
  const [width, setWidth] = useState<number>()

  const ref = useCallback((el: HTMLDivElement | null) => {
    if (!el) return
    setWidth(el.offsetWidth)
  }, [])

  return [ref, width] as const
}

export default useContainerWidth
